<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <div class="f-grid-ind">
          <div class="f-grid-col-ind" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
            <div class="ind-text">Công ty</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn công ty" :limit="company_obj.limit" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @keyup="emitEvent" @offset="changeOffset" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind">
            <div class="ind-text">Khu vực</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn" :limit="areas_obj.limit" :loading="areas_obj.loading" v-model="areas" :options="areas_obj.items" :total="areas_obj.total" @keyup="emitEventAreas" @offset="changeOffsetAreas" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind">
            <div class="ind-text">Bộ phận</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn" :limit="department_obj.limit" :loading="department_obj.loading" v-model="department" :options="department_obj.items" :total="department_obj.total" @keyup="emitEventAreas" @offset="changeOffsetAreas" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind">
            <div class="ind-text">Công việc</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn" :limit="work_obj.limit" :loading="work_obj.loading" v-model="work" :options="work_obj.items" :total="work_obj.total" @keyup="emitEventWork" @offset="changeOffsetWork" :showClear="true"/>
            </div>
          </div>
        </div>
        <div class="f-grid-ind">
          <div class="f-grid-col-ind">
            <div class="ind-text">Phiếu đánh giá <span style="color:red">*</span></div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn" :limit="evaluation_form_obj.limit" :loading="evaluation_form_obj.loading" v-model="evaluation_form" :options="evaluation_form_obj.items" :total="evaluation_form_obj.total" @keyup="emitEventEvaluation" @offset="changeOffsetEvaluation" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind">
            <div class="ind-text">Trạng thái</div>
            <div class="idn-sel" style="margin-top: 4px;">
              <InputText disabled
                v-model="status_text"
                type="text"
                style="width:100%;background-color:#EEEEEE"
              />
            </div>
          </div>
          <div class="f-grid-col-ind">
            <div class="ind-text">Danh mục mối nguy</div>
            <div class="idn-sel">
            <DropdownScrollable placeholder="Chọn" :limit="ind_category_obj.limit" :loading="ind_category_obj.loading" v-model="ind_category" :options="ind_category_obj.items" :total="ind_category_obj.total" @keyup="emitEventCategoryIndex" @offset="changeOffsetCategoryIndex" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind">
            <div class="ind-text">Phân loại tình huống</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn" v-model="type_situation_index" :options="type_situation_list" :showClear="true"/>
            </div>
          </div>
        </div>
        
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model="dataModel"
          :options="options"
          :filterDefault="filters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @showPopup="showPopup"
          @onDataChange="DataOnChange"
          :company="company"
          :company_id="company_id"
          :evaluation_form="evaluation_form"
          :ind_category="ind_category"
          :type_situation_index="type_situation_index"
        ></BaseDatatable>
        <Dialog
          style=""
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Bạn có chắc muốn xóa mối nguy này không này không?
          <template
            #footer
          >
          <Button
          label="Hủy"
          @click="showDeleteDialog = false"
          icon="pi pi-times"
          class="p-button-warning callback-btn"
          />
          <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>
        <Dialog
          style=""
          header="Chi tiết đánh giá rủi ro"
          :visible.sync="showDetailDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          <table style="width:360px">
            <tr>
              <th style="width: 20%;">Tiêu chí</th>
              <th style="width: 20%;">Điểm</th>
              <th>Mức độ</th>
            </tr>
            <tr v-for="(item, index) in data_popup.list" :key="index">
              <td style="vertical-align: top;">{{item.code}}</td>
              <td style="vertical-align: top;">{{item.point}}</td>
              <td style="vertical-align: top;">{{item.name}}</td>
            </tr>
            <tr style="height: 34px;vertical-align: bottom;">
              <td>R</td>
              <td>{{data_popup.point}}</td>
              <td>{{data_popup.code}}</td>
            </tr>
          </table>
          <template
            #footer
          >
          <Button label="Đóng" icon="pi pi-check" class="p-button-success main-style-button"
            @click="showDetailDialog = false"
          />
          </template>
        </Dialog>
      </div>
    </div>
    <Dialog :header="hearderTitle()" :visible.sync="showAddDialog" :contentStyle="{overflow: 'visible'}" :modal="true" class="dialog-min">
      <form id="frm_action_p">
        <div class="" style="width: 350px;">
          <label class="txt-right">Phiếu đánh giá<span class="required"></span></label>
          <DropdownScrollable placeholder="Chọn" :showClear="true" width="100%" cusClass="m-0"
            :multiple="false"
            :limit="evaluation_form_popup_obj.limit"
            :loading="evaluation_form_popup_obj.loading"
            v-model="evaluation_form_popup"
            :options="evaluation_form_popup_obj.items"
            :total="evaluation_form_popup_obj.total"
            @keyup="emitEventEvaluationFormPopup"
            @scroll="emitEventEvaluationFormPopup"
            @offset="changeOffsetEvaluationFormPopup"
            />
          <input class="input_tmp_validator" id="evaluation_form_popup" />
        </div>
        <div class="cus-popup-lable">
          <label class="txt-right">Tình huống công việc<span class="required"></span></label>
          <DropdownScrollable placeholder="Chọn" :showClear="true" width="100%" cusClass="m-0"
            :multiple="false"
            :limit="situation_obj.limit"
            :loading="situation_obj.loading"
            v-model="situation"
            :options="situation_obj.items"
            :total="situation_obj.total"
            @keyup="emitEventSituation"
            @scroll="emitEventSituation"
            @offset="changeOffsetSituation"
            />
          <input class="input_tmp_validator" id="situation" />
        </div>
        <div v-if="situation && situation.type=='other'" class="">
          <label class="txt-right">Tên tình huống khác<span class="required"></span></label>
          <InputText
            v-model="other_situation_name"
            type="text"
            class="input-text-box"
            style="width:100%"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="other_situation_name" />
        </div>
        <div class="cus-popup-lable">
          <label class="txt-right">Phân loại tình huống<span class="required"></span></label>
          <DropdownScrollable defaultLabel="name" :showClear="false" readonly cusClass="m-0" width="100%" v-model="type_situation" :options="type_situation_list"/>

          <!-- <DropdownScrollable placeholder="Chọn" :showClear="false" width="100%" cusClass="m-0"
            v-model="type_situation"
            :options="type_situation_list"
          /> -->
          <input class="input_tmp_validator" id="type_situation" />
        </div>
        <div class="cus-popup-lable">
          <label class="txt-right">Danh mục mối nguy<span class="required"></span></label>
          <DropdownScrollable placeholder="Chọn" :showClear="true" width="100%" cusClass="m-0"
            :multiple="false"
            :limit="category_obj.limit"
            :loading="category_obj.loading"
            v-model="category"
            :options="category_obj.items"
            :total="category_obj.total"
            @keyup="emitEventCategory"
            @scroll="emitEventCategory"
            @offset="changeOffsetCategory"
            />
          <input class="input_tmp_validator" id="category" />
        </div>
        <div class="cus-popup-lable">
          <label class="txt-right">Mối nguy<span class="required"></span></label>
          <DropdownScrollable placeholder="Chọn" :showClear="true" width="100%" cusClass="m-0"
            :multiple="false"
            :limit="danger_obj.limit"
            :loading="danger_obj.loading"
            v-model="danger"
            :options="danger_obj.items"
            :total="danger_obj.total"
            @keyup="emitEventDanger"
            @scroll="emitEventDanger"
            @offset="changeOffsetDanger"
            />
          <input class="input_tmp_validator" id="danger" />
        </div>
        <div v-if="danger && danger.type=='other'" class="cus-popup-lable">
          <label class="txt-right">Khác<span class="required"></span></label>
          <InputText
            v-model="other_danger_name"
            type="text"
            class="input-text-box"
            placeholder="Nhập"
            style="width:100%"
          />
          <input class="input_tmp_validator" id="other_danger_name" />
        </div>
      </form>
      <template #footer>
        <Button label="Hủy" @click="showAddDialog = false" icon="pi pi-times" class="p-button-warning-b callback-btn-o" /> 
        <Button label="Xác nhận" @click="EditData()" icon="pi pi-check" class="" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from './list'
import DropdownScrollable from '@/components/DropdownScrollable';
export default {
  components: {
    BaseDatatable,
    DropdownScrollable
  },
  data() {
    return {
      filters : {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      showDetailDialog : false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      company: {},
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      company_id: null,
      evaluation_form_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      evaluation_form : {},
      data_popup :{
        list : [],
        point : null,
        code :""
      },
      hearder_title : 'Thêm mối nguy',
      evaluation_form_popup : {},
      evaluation_form_popup_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      situation : {},
      situation_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      type_situation_list : [{id : "PERIODIC" , name : "Định kỳ"},{id : "ABMORMAL" , name : "Bất thường"},{id : "FREQUENT" , name : "Thường xuyên"}],
      type_situation : {id : "PERIODIC" , name : "Định kỳ"},
      category_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      category : {},
      danger_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      danger : {},
      other_danger_name : '',
      other_situation_name : '',
      showAddDialog : false,
      id_edit : null,
      show_edit: false,
      situation_ref_id : null,
      danger_ref_id : null,
      areas : {},
      areas_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      department : {},
      department_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      work : {},
      work_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      status_text : '',
      type_situation_index : null,
      ind_category : null,
      ind_category_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      type_change : 'company',
      is_load_data: false
    }
  },
  // mounted () {
    
  // },
  async created() {
    this.initParams();
    await this.getListCompany();
    this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
    this.modelName = this.$route.meta.model;
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      console.log("this.$route.query.company_id", this.$route.query.company_id);
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        this.company = {id: this.$route.query.company_id};
        setTimeout(() => {
          const query = Object.assign({}, this.$route.query);
          delete query.company_id;
          this.$router.replace({ query });
        }, 100);
      }
    }
    
  },
  watch: {
    '$route': 'initParams',
    async 'company'() {
      console.log("companycompany")
      this.is_load_data = true
      if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company_id = this.company.id;
      }
      //đổi công ty thì reset lại data và gán phiếu = phiếu đầu tiên
      this.evaluation_form_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      this.clearAreas()
      this.clearDepartment()
      // this.clearWork()
      this.clearCategoryIndex()
      this.getListAreas()
      this.getListDepartment()
      // this.getListWork()
      await this.getListEvaluation('company')
      this.is_load_data = false
      this.getListCategoryIndex()
    },
    async 'areas'(){
      if(this.is_load_data == true){
        return
      }
      console.log("areas===",this.areas)
      this.evaluation_form = {}
      this.clearEvaluationFrom()
      this.getListEvaluation()
    },
    async 'department'(){
      if(this.is_load_data == true){
        return
      }
      console.log("department===",this.department)
      this.clearWork()
      this.getListWork()
      this.evaluation_form = {}
      this.clearEvaluationFrom()
    },
    async 'work'(){
      if(this.is_load_data == true){
        return
      }
      console.log("work===",this.work)
      this.evaluation_form = {}
      this.clearEvaluationFrom()
      this.getListEvaluation()
    },
    "company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company = {id: this.company_id};
        // this.componentKey++;
      }
    },
    "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        // this.company = {id: this.company_id};
        // this.componentKey++;
      }
    },
    "evaluation_form"(){
      console.log("evaluation_formevaluation_formevaluation_form")
      this.status_text = ''
      if(!this.$commonFuction.isEmptyObject(this.evaluation_form)){
        this.getStatus(this.evaluation_form.status)
      }
      this.componentKey++;
    },
    async "evaluation_form_popup"(){
      if(this.show_edit == false){
        this.clearSituation()
        this.clearCategory()
        this.clearDanger()
        this.showAddDialog = true
        // this.type_situation = {id : "PERIODIC" , name : "Định kỳ"};
      }
      await this.getListSituation();
      await this.getListCategory();
    },
    async "category"() {
      if(this.show_edit == false){
        this.clearDanger()
      }
      await this.getListDanger();
    },
    async 'ind_category'(){
      this.componentKey++;
    },
    async 'type_situation_index'(){
      this.componentKey++;
    },
  },
  methods: {
    emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.company_obj.offset = value;
      // this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.company_obj.offset > 0 ) {
            this.company_obj.items.push(...res.data.data.company);
          } else{
            this.company_obj.items = res.data.data.company;
          }
          this.company_objs = res.data.data.company
          this.company_obj.total = res.data.data.total;
          this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },
    emitEventEvaluation(keyword){
      this.$delete(this.evaluation_form_obj.filters, 'name');
      if (keyword) {
        this.evaluation_form_obj.filters.name = keyword;
      }
      this.getListEvaluation();
    },
    changeOffsetEvaluation(value) {
      this.evaluation_form_obj.offset = value;
      // this.getListEvaluation();
    },
    async getListEvaluation(key='') {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.evaluation_form = {};
        return;
      }
      this.$delete(this.evaluation_form_obj.filters, 'areas_id');
      if (!this.$commonFuction.isEmptyObject(this.areas)) {
        this.evaluation_form_obj.filters.areas_id = this.areas.id
      }
      this.$delete(this.evaluation_form_obj.filters, 'department_id');
      if (!this.$commonFuction.isEmptyObject(this.department)) {
        this.evaluation_form_obj.filters.department_id = this.department.id
      }
      this.$delete(this.evaluation_form_obj.filters, 'work_id');
      if (!this.$commonFuction.isEmptyObject(this.work)) {
        this.evaluation_form_obj.filters.work_id = this.work.id
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        this.evaluation_form_obj.loading = true;
        await ApiRepository.post("/_api/evaluation_form/options", {filters: this.evaluation_form_obj.filters, limit: this.evaluation_form_obj.limit, offset: this.evaluation_form_obj.offset , company_id : this.company.id}, {headers}).then((res) => {
          if (this.evaluation_form_obj.offset > 0 ) {
            this.evaluation_form_obj.items.push(...res.data.data.list);
          } else{
            this.evaluation_form_obj.items = res.data.data.list;
            if(res.data.data.list.length > 0){
              if(key == 'company'){//đổi công ty
                this.evaluation_form = res.data.data.list[0]
              }
            }else{
              if(key == 'company'){
                this.evaluation_form = {}
              }
            }
          }
          this.evaluation_form_obj.total = res.data.data.total;
          this.evaluation_form_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.evaluation_form_obj.loading = false;
        })
      }
    },
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
      // this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
      //   let dataUpdate = {}
      //   if(f.key == 'active'){
      //     dataUpdate['active'] = data[f.key]
      //   }
      //   let variables = {
      //     'data_update': dataUpdate,
      //     'where_key': {
      //       'id': {'_eq': data.id}
      //     }
      //   };
      //   this.$apollo.mutate({
      //     mutation: DataServices.updateData(this.modelName),
      //     variables: variables
      //   }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      
      if (that.$store.getters.controllers?.list_danger && that.$store.getters.controllers?.list_danger.includes('add')) {
        actions.header = {name: 'add', icon: 'plus', path: `list-danger/add`, title: 'Thêm'};
      }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        // console.log("rowData",rowData)
        var buttons = {}
        let user_id = that.$store.getters.user;
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        if (that.$store.getters.controllers?.list_danger && that.$store.getters.controllers?.list_danger.includes('edit')) {
          buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-danger/edit/`, title: 'Sửa'};
        }
        if (that.$store.getters.controllers?.list_danger && that.$store.getters.controllers?.list_danger.includes('delete')) {
          buttons.delete = {name: 'delete', icon: 'trash', key: 'id', title: 'Xóa'};
        }
        if(that.$store.getters.controllers?.list_danger && that.$store.getters.controllers?.list_danger.includes('history')){
          buttons.history = {name: 'history',path:'list-danger/history', icon: '', key: 'id', title: 'Lịch sử'};
        }
        var checkshowEval = false
        if(rowData.evaluation_form_status == 'NEW'){
            if(that.$store.getters.type == that.$constants.TYPE_USER.SUPPER_ADMIN || that.$store.getters.type == that.$constants.TYPE_USER.COMPANY){
              checkshowEval = true
            }else if(user_id == rowData.uid_implementer){
              checkshowEval = true
            }
          }else if(rowData.evaluation_form_status == 'REVIEW'){
            if(that.$store.getters.type == that.$constants.TYPE_USER.SUPPER_ADMIN || that.$store.getters.type == that.$constants.TYPE_USER.COMPANY){
              checkshowEval = true
            }else if(user_id == rowData.uid_review){
              checkshowEval = true
            }
          }else if(rowData.evaluation_form_status == 'WAITTING_APPROVED'){
            if(that.$store.getters.type == that.$constants.TYPE_USER.SUPPER_ADMIN || that.$store.getters.type == that.$constants.TYPE_USER.COMPANY){
              checkshowEval = true
            }else if(user_id == rowData.uid_approve){
              checkshowEval = true
            }
          }else if(rowData.evaluation_form_status == 'APPROVE'){
            if(that.$store.getters.type == that.$constants.TYPE_USER.SUPPER_ADMIN){
              checkshowEval = true
            }else if(that.$store.getters.type == that.$constants.TYPE_USER.COMPANY){
              if(that.$store.getters.controllers?.evaluation_form && that.$store.getters.controllers?.evaluation_form.includes('close')){
                checkshowEval = true
              }
            }else if(that.$store.getters.controllers?.evaluation_form && that.$store.getters.controllers?.evaluation_form.includes('close')){
              checkshowEval = true
            }
          }
          if(checkshowEval == true){
            buttons.evaluation = {name: 'evaluation', icon: '', key: 'id',path: `list-danger/evaluation/`, title: 'Đánh giá'};
          }

        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async callbackOptions() {
      this.dataModel.getDisplayFields();
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key]})
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.situation_ref_id = null
          this.danger_ref_id = null
          this.show_edit = true
          this.hearder_title = 'Chỉnh sửa mối nguy'
          console.log("data.data",data.data)
          this.evaluation_form_popup = {id : data.data.evaluation_form_id,name : data.data.evaluation_form_name}
          this.situation = {id : data.data.situation_id, name : data.data.situation_name,type : data.data.situation_type}
          this.other_situation_name = data.data.other_situation_name
          this.category = {id : data.data.category_id, name :  data.data.category_name}
          this.danger = {id : data.data.danger_id, name :  data.data.danger_name ,type : data.data.danger_type}
          console.log("danger",this.danger)
          this.other_danger_name = data.data.other_danger_name
          this.situation_ref_id = data.data.situation_ref_id ?? null
          this.danger_ref_id = data.data.danger_ref_id ?? null
          await this.getListEvaluationFormPopup()
          this.id_edit = data.data.id
          this.show_edit = false
          this.showAddDialog = true
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name_en
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'add':
          if (this.$commonFuction.isEmptyObject(this.company)) {
            alert("Vui lòng chọn công ty!")
            return;
          }
          this.hearder_title = 'Thêm mối nguy'
          this.evaluation_form_popup = {}
          await this.getListEvaluationFormPopup()
          this.showAddDialog = true
          break
        case 'history':
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.$router.push({ path: action.path ,query: { page_transaction: pageTransaction.toString(), company_id: this.company_id ,efd_id:data.data.id}  })
          break
        case 'evaluation':
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString(), company_id: this.company_id }  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async deleteData() {
      this.showDeleteDialog = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/evaluation_form_danger/delete", {id: that.deleteId, company_id: that.company.id}, {headers}).then(function () {
          that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa thành công', life: 3000 })
          that.componentKey += 1;
        }).catch((err) => {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          })
        })
      }
    },
    async showPopup(data,key){
      var id = data.id
      this.$commonFuction.is_loading(true);
      if(id){
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
          const headers = {
            "Authorization": "Bearer "+token,
          };
          var that = this;
          await ApiRepository.post("/_api/evaluation_form_danger/risk", {id: id, company_id: that.company.id}, {headers}).then(function (response) {
            var resp = response.data.data;
            var tmp = []
            var code = ""
            var total = null
            if(key=='rb'){
              for (let i = 0; i < resp.risk_assessment.length; i++) {
                let e = resp.risk_assessment[i];
                let name = ''
                if(e.criteria_json && e.criteria_json.level){
                  name = e.criteria_json.level.name ?? ''
                }
                tmp.push({
                  code : e.criteria_json?.code,
                  point : that.formatNumber(e.point,0),
                  name : name
                })
              }
              code = data.code_rb
              total = that.formatNumber(data.point_rb,0)
            }else if(key=='ra'){
              for (let i = 0; i < resp.risk_assessment_ra.length; i++) {
                let e = resp.risk_assessment_ra[i];
                let name = ''
                if(e.criteria_json && e.criteria_json.level){
                  name = e.criteria_json.level.name ?? ''
                }
                tmp.push({
                  code : e.criteria_json?.code,
                  point : that.formatNumber(e.point,0),
                  name :name,
                })
              }
              code = data.code_ra
              total = that.formatNumber(data.point_ra,0)
            }else{
              for (let i = 0; i < resp.risk_assessment_re.length; i++) {
                let e = resp.risk_assessment_re[i];
                let name = ''
                if(e.criteria_json && e.criteria_json.level){
                  name = e.criteria_json.level.name ?? ''
                }
                tmp.push({
                  code : e.criteria_json?.code,
                  point : that.formatNumber(e.point,0),
                  name : name,
                })
              }
              code = data.code_re
              total = that.formatNumber(data.point_re,0)
            }
            that.data_popup = {
              list : tmp,
              point : total,
              code : code
            }
            that.showDetailDialog = true;
            that.$commonFuction.is_loading(false);
            // console.log("datadata=",that.data_popup)
          }).catch((err) => {
            that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
            })
          })
        }
      }
      this.$commonFuction.is_loading(false);
    },
    formatNumber(value,decimals=2){
      const digitsRE = /(\d{3})(?=\d)/g
      value = parseFloat(value)
      if (!isFinite(value) || (!value && value !== 0)) return ''
      decimals = decimals != null ? decimals : 2
      var stringified = Math.abs(value).toFixed(decimals)
      var _int = decimals
        ? stringified.slice(0, -1 - decimals)
        : stringified
      var i = _int.length % 3
      var head = i > 0
        ? (_int.slice(0, i) + (_int.length > 3 ? '.' : ''))
        : ''
      var _float = decimals
        ? stringified.slice(-1 - decimals)
        : ''
      var sign = value < 0 ? '-' : '';
      var text = sign + head +
        _int.slice(i).replace(digitsRE, '$1.') +
        _float
      return text
    },
    hearderTitle(){
      return this.hearder_title
    },
    emitEventDanger(keyword) {
      // console.log(keyword);
      this.$delete(this.danger_obj.filters, 'name');
      if (keyword) {
        this.danger_obj.filters.name = keyword;
      }
      this.getListDanger();
    },
    changeOffsetDanger(value) {
      this.danger_obj.offset = value;
    },
    async getListDanger() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      if(this.$commonFuction.isEmptyObject(this.category)) {
        return;
      }
      this.danger_obj.filters.category_id = this.category.id
      this.danger_obj.filters.active = true
      this.danger_obj.filters.status = 'APPROVED'
      this.danger_obj.filters.get_other = true
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.danger_obj.loading = true;
        await ApiRepository.post("/_api/danger/options", {filters: this.danger_obj.filters, limit: this.danger_obj.limit, offset: this.danger_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            if (this.danger_obj.offset > 0 ) {
              this.danger_obj.items.push(...tmp);
            } else{
              this.danger_obj.items= tmp;
            }
            this.danger_obj.total = res.data.data.total;
            this.danger_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.danger_obj.loading = false;
        })
      }
    },
    emitEventCategory(keyword) {
      // console.log(keyword);
      this.$delete(this.category_obj.filters, 'name');
      if (keyword) {
        this.category_obj.filters.name = keyword;
      }
      this.getListCategory();
    },
    changeOffsetCategory(value) {
      this.category_obj.offset = value;
    },
    async getListCategory() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.category_obj.loading = true;
        await ApiRepository.post("/_api/category/options", {filters: this.category_obj.filters, limit: this.category_obj.limit, offset: this.category_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            if (this.category_obj.offset > 0 ) {
              this.category_obj.items.push(...tmp);
            } else{
              this.category_obj.items = tmp;
            }
            this.category_obj.total = res.data.data.total;
            this.category_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.category_obj.loading = false;
        })
      }
    },
    emitEventSituation(keyword) {
      // console.log(keyword);
      this.$delete(this.situation_obj.filters, 'name');
      if (keyword) {
        this.situation_obj.filters.name = keyword;
      }
      this.getListSituation();
    },
    changeOffsetSituation(value) {
      this.situation_obj.offset = value;
    },
    async getListSituation() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      if(this.$commonFuction.isEmptyObject(this.evaluation_form_popup)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      this.situation_obj.filters.work_id = this.evaluation_form_popup.work_id
      this.situation_obj.filters.active = true
      this.situation_obj.filters.status = 'APPROVED'
      this.situation_obj.filters.get_other = true
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.situation_obj.loading = true;
        await ApiRepository.post("/_api/situation/options", {filters: this.situation_obj.filters, limit: this.situation_obj.limit, offset: this.situation_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            if (this.situation_obj.offset > 0 ) {
              this.situation_obj.items.push(...tmp);
            } else{
              this.situation_obj.items = tmp;
            }
            this.situation_obj.total = res.data.data.total;
            this.situation_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.situation_obj.loading = false;
        })
      }
    },

    emitEventEvaluationFormPopup(keyword){
      this.$delete(this.evaluation_form_popup_obj.filters, 'name');
      if (keyword) {
        this.evaluation_form_popup_obj.filters.name = keyword;
      }
      this.getListEvaluationFormPopup();
    },
    changeOffsetEvaluationFormPopup(value) {
      this.evaluation_form_popup_obj.offset = value;
      // this.getListEvaluationFormPopup();
    },
    async getListEvaluationFormPopup() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.evaluation_form_popup = {};
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        this.evaluation_form_popup_obj.loading = true;
        await ApiRepository.post("/_api/evaluation_form/options", {filters: this.evaluation_form_popup_obj.filters, limit: this.evaluation_form_popup_obj.limit, offset: this.evaluation_form_popup_obj.offset , company_id : this.company.id}, {headers}).then((res) => {
          if (this.evaluation_form_popup_obj.offset > 0 ) {
            this.evaluation_form_popup_obj.items.push(...res.data.data.list);
          } else{
            this.evaluation_form_popup_obj.items = res.data.data.list;
            
          }
          this.evaluation_form_popup_obj.total = res.data.data.total;
          this.evaluation_form_popup_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.evaluation_form_popup_obj.loading = false;
        })
      }
    },
    clearSituation(){
      this.situation_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.situation = {}
      this.other_situation_name = ''
    },
    clearCategory(){
      this.category_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.category = {}
    },
    clearDanger(){
      this.danger_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.danger = {}
      this.other_danger_name = ''
    },
    async EditData(){
      this.$commonFuction.is_loading(true);
      var id_edit = this.id_edit ? this.id_edit : null
      this.other_danger_name.trim()
      this.other_situation_name.trim()
      let situation = this.situation
      let type_situation = this.type_situation
      let category = this.category
      let danger = this.danger
      let other_danger_name =  this.other_danger_name
      let other_situation_name = this.other_situation_name
      
      let check_e = await this.validateDataAdd()
      if(check_e){
        this.$commonFuction.is_loading(false);
        return
      }
      var check_exsit_e = await this.checkExsit()
      
      //gọi api kiểm tra tồn tại chưa

      if(check_exsit_e){
        this.$commonFuction.is_loading(false);
        alert("Mối nguy đã tồn tại!")
        return;
      }
      //gọi api cập nhật
      let objects = {
        evaluation_form_id : this.evaluation_form_popup.id,
        work_id : this.evaluation_form_popup.work_id,
        danger : danger,
        situation : situation,
        type : type_situation.id,
        category_id : category.id,
        other_danger_name : other_danger_name,
        other_situation_name : other_situation_name,
        company_id : this.company.id,
      }
      // if(objects){
      //   this.$commonFuction.is_loading(false);
      //   console.log("objects",objects)
      //   return
      // }
      if(id_edit){
        objects.id = this.id_edit
      }

      var token = this.$store.getters.token ? this.$store.getters.token : null
      var that = this
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        await ApiRepository.post("/_api/evaluation_form_danger/update", objects, {headers}).then(async function (response) {
          if (response.status === 200) {
            that.reloadData();
          } else {
            that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: response.data.message,
                life: 3000
            });
            that.$commonFuction.is_loading(false);
          }
        }).catch((err) => {
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
          that.$commonFuction.is_loading(false);
        })
      }
    },
    async reloadData(){
      this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Lưu dữ liệu thành công', life: 3000 })
      this.showAddDialog = false
      this.$commonFuction.is_loading(false);
      this.componentKey++
    },
    async validateDataAdd(){
      let evaluation_form_popup = document.getElementById("evaluation_form_popup");
      if (this.$commonFuction.isEmptyObject(this.evaluation_form_popup) ||
        this.$commonFuction.isEmpty(this.evaluation_form_popup)) {
        evaluation_form_popup.setCustomValidity("Phiếu đánh giá không được để trống!");
      }else{
        evaluation_form_popup.setCustomValidity("");
      }
      let situation_add = document.getElementById("situation");
      if (this.$commonFuction.isEmptyObject(this.situation) ||
        this.$commonFuction.isEmpty(this.situation)) {
        situation_add.setCustomValidity("Tình huống công việc không được để trống!");
      } else {
        if(this.situation.type == "other"){
          let other_situation_name_add = document.getElementById("other_situation_name")
          if (this.other_situation_name == undefined || this.other_situation_name == null || this.other_situation_name == ""
          ) {
            other_situation_name_add.setCustomValidity("Tên tình huống khác không được để trống!");
          } else if (this.other_situation_name.length > 255) {
            other_situation_name_add.setCustomValidity("Tên tình huống khác không được quá 255 ký tự!");
          } else {
            //kiểm tra tên đã tồn tại chưa
            var check_name = await this.CheckNameSituation()
            // console.log("check_name",check_name)
            if(check_name || this.other_situation_name.toLowerCase() == 'khác'){
              other_situation_name_add.setCustomValidity("Tên tình huống đã tồn tại trên hệ thống");
            }else {
              other_situation_name_add.setCustomValidity("");
            }
          }
        }
        situation_add.setCustomValidity("");
      }
      let type_situation_add = document.getElementById("type_situation");
      
      if (!this.type_situation) {
        type_situation_add.setCustomValidity("Phân loại tình huống không được để trống!");
      } else {
        type_situation_add.setCustomValidity("");
      }
      let category_add = document.getElementById("category");
      if (this.$commonFuction.isEmptyObject(this.category) ||
        this.$commonFuction.isEmpty(this.category)) {
        category_add.setCustomValidity("Danh mục mối nguy không được để trống!");
      } else {
        category_add.setCustomValidity("");
      }
      let danger_add = document.getElementById("danger");
      if (this.$commonFuction.isEmptyObject(this.danger) || this.$commonFuction.isEmpty(this.danger)) {
        danger_add.setCustomValidity("Mối nguy không được để trống!");
      } else {
        if(this.danger.type == "other"){
          let other_danger_name_add = document.getElementById("other_danger_name")
          if (this.other_danger_name == undefined || this.other_danger_name == null || this.other_danger_name == ""
          ) {
            other_danger_name_add.setCustomValidity("Tên mối nguy khác không được để trống!");
          } else if (this.other_danger_name.length > 255) {
            other_danger_name_add.setCustomValidity("Tên mối nguy khác không được quá 255 ký tự!");
          } else {
            //kiểm tra tên đã tồn tại chưa
            var check_name_danger = await this.CheckNameDanger()
            if(check_name_danger || this.other_danger_name.toLowerCase() == 'khác'){
              other_danger_name_add.setCustomValidity("Tên mối nguy đã tồn tại trên hệ thống");
            }else {
              other_danger_name_add.setCustomValidity("");
            }
          }
        }
        danger_add.setCustomValidity("");
      }
      var inpObj = document.getElementById("frm_action_p");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async CheckNameSituation(){
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return false;
      }
      if (this.$commonFuction.isEmptyObject(this.situation)) {
        return false;
      }
      if (this.$commonFuction.isEmptyObject(this.evaluation_form_popup)) {
        return false;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        var check = false
        await ApiRepository.post("/_api/situation/check_name", {situation_id : this.situation_ref_id,work_id: this.evaluation_form_popup.work_id,name:this.other_situation_name,company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.data
            if(tmp && tmp.id){
              check = true
            }
        }).catch((err) => {
            console.log(err);
        })
        return check
      }
    },
    async CheckNameDanger(){
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return false;
      }
      if (this.$commonFuction.isEmptyObject(this.category)) {
        return false;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        var check = false
        await ApiRepository.post("/_api/danger/check_name", {danger_id : this.danger_ref_id,category_id: this.category.id,name:this.other_danger_name,company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.data
            if(tmp && tmp.id){
              check = true
            }
        }).catch((err) => {
            console.log(err);
        })
        return check
      }
    },
    async checkExsit(){
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        var object = {
          id : this.id_edit ?? null,
          company_id: this.company.id,
          category_id: this.category.id,
          situation: this.situation,
          danger : this.danger,
          other_danger_name:this.other_danger_name,
          other_situation_name:this.other_danger_name,
          evaluation_form_id : this.evaluation_form_popup.id
        }
        var check = false
        await ApiRepository.post("/_api/evaluation_form_danger/check_exsit", object, {headers}).then((res) => {
          console.log("res.data.data",res.data.data)
          check = res.data.data.check_exsit
          
        }).catch((err) => {
            console.log(err);
        })
        return check
      }
    },
    emitEventAreas(keyword) {
      // console.log(keyword);
      this.$delete(this.areas_obj.filters, 'name');
      if (keyword) {
        this.areas_obj.filters.name = keyword;
      }
      this.getListAreas();
    },
    changeOffsetAreas(value) {
      this.areas_obj.offset = value;
    },
    async getListAreas() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.areas_obj.loading = true;
        await ApiRepository.post("/_api/area/options", {filters: this.areas_obj.filters, limit: this.areas_obj.limit, offset: this.areas_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.areas_obj.offset > 0 ) {
              this.areas_obj.items.push(...res.data.data.area);
            } else{
              this.areas_obj.items = res.data.data.area;
            }
            this.areas_obj.total = res.data.data.count;
            this.areas_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.areas_obj.loading = false;
        })
      }
    },
    emitEventDepartment(keyword) {
      // console.log(keyword);
      this.$delete(this.department_obj.filters, 'name');
      if (keyword) {
        this.department_obj.filters.name = keyword;
      }
      this.getListDepartment();
    },
    changeOffsetDepartment(value) {
      this.department_obj.offset = value;
    },
    async getListDepartment() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      this.department_obj.filters.active = true;
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.department_obj.loading = true;
        await ApiRepository.post("/_api/department/options", {filters: this.department_obj.filters, limit: this.department_obj.limit, offset: this.department_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.department_obj.offset > 0 ) {
              this.department_obj.items.push(...res.data.data.department);
            } else{
              this.department_obj.items = res.data.data.department;
            }
            this.department_obj.total = res.data.data.count;
            this.department_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.department_obj.loading = false;
        })
      }
    },
    emitEventWork(keyword) {
      // console.log(keyword);
      this.$delete(this.work_obj.filters, 'name');
      if (keyword) {
        this.work_obj.filters.name = keyword;
      }
      this.getListWork();
    },
    changeOffsetWork(value) {
      this.work_obj.offset = value;
    },
    async getListWork() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      this.$delete(this.work_obj.filters, 'department_id');
      if(!this.$commonFuction.isEmptyObject(this.department)){
        this.work_obj.filters.department_id = this.department.id
      }
      this.work_obj.filters.active = true
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        }
        this.work_obj.loading = true;
        await ApiRepository.post("/_api/work/options", {filters: this.work_obj.filters, limit: this.work_obj.limit, offset: this.work_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.work_obj.offset > 0 ) {
            this.work_obj.items.push(...res.data.data.list);
          } else{
            this.work_obj.items = res.data.data.list;
          }
          this.work_obj.total = res.data.data.total;
          this.work_obj.loading = false;
        }).catch((err) => {
          console.log(err);
          this.work_obj.loading = false;
        })
      }
    },
    clearAreas(){
      this.areas_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.areas = {}
    },
    clearWork(){
      this.work_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.work = {}
    },
    clearDepartment(){
      this.department_obj ={
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.department = {}
    },
    getStatus(status=''){
      var text_status = ''
      if(status == 'NEW'){
        text_status = "Mới"
      }else if(status == 'REVIEW'){
        text_status = "Chờ review"
      }else if(status == 'WAITTING_APPROVED'){
        text_status = "Chờ approve"
      }else if(status == 'APPROVE'){
        text_status = "Đã approve"
      }else if(status == 'COMPLETE'){
        text_status = "Đã đóng"
      }
      this.status_text = text_status
    },
    emitEventCategoryIndex(keyword) {
      // console.log(keyword);
      this.$delete(this.ind_category_obj.filters, 'name');
      if (keyword) {
        this.ind_category_obj.filters.name = keyword;
      }
      this.getListCategoryIndex();
    },
    changeOffsetCategoryIndex(value) {
      this.ind_category_obj.offset = value;
    },
    async getListCategoryIndex() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.ind_category_obj.loading = true;
        await ApiRepository.post("/_api/category/options", {filters: this.ind_category_obj.filters, limit: this.ind_category_obj.limit, offset: this.ind_category_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            if (this.ind_category_obj.offset > 0 ) {
              this.ind_category_obj.items.push(...tmp);
            } else{
              this.ind_category_obj.items = tmp;
            }
            this.ind_category_obj.total = res.data.data.total;
            this.ind_category_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.ind_category_obj.loading = false;
        })
      }
    },
    clearCategoryIndex(){
      this.ind_category_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.ind_category = null
    },
    clearEvaluationFrom(){
      this.evaluation_form_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
    },
  },
  
}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-button-warning-o .p-button-label-o{
  color: #e95d57;
}
.p-button-warning .pi-times{
  color: #e95d57;
}
.p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:450px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 133px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 5px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
.f-grid-ind {
  display: flex;
  margin-left: -1rem;
  flex-flow: row wrap;
}

.f-grid-col-ind {
  width: 25% !important;
  padding: 0rem 0rem 0rem 1rem;
}
.ind-text { 
  font-weight: 600;
}
.idn-sel {
  margin-top: -6px;
}
.p-button-warning-b .p-button-label{
  color: #000000;
}
.p-button-warning-b .pi-times{
  color: #000000;
}
.callback-btn-o {
  border-color: #00000029 !important;
  background-color: #00000029 !important;
}
</style>